module.exports = __webpack_public_path__ + "img/img_xinxianquan.18cb2b27.png";